import { required } from "vuelidate/lib/validators";

export default class TerminalData {
  nome = "";
  uuid_terminal = "";

  constructor({ nome = "", uuid_terminal = "" }) {
    this.nome = nome;
    this.uuid_terminal = uuid_terminal;
  }
}

export const TerminalDataRequired = {
  nome: {
    required,
  },
};
